import contentTemplate from 'properties/style/text-style.ejs';
import BasePropertyView from 'BasePropertyView.js'
import themeService     from 'ThemeService.js';
import Immutable                from 'immutable';
import constants            from 'Constants.js';
import listService          from 'ListService';
import ThemeService          from 'ThemeService';

class StyleTextStyle extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

         this.events = {
            'click #boldText, #italicText' : 'updateTextStyleAttributes'
         };

        let _textWeight = ThemeService.isThemeProperty(this.model.get('textWeight')) ? this.resolveAttributes(this.model.get('textWeight'), 'textWeight') : this.model.get('textWeight');        
        const weights = ['bold', 'bold !important']; 

        if (!_textWeight) {
            _textWeight = 'normal';
            this.model.set('boldSelection', this.unselectedColor, {silent:true});
        }else if (weights.includes(_textWeight)) {
            this.model.set('boldSelection', this.selectedColor, {silent:true});
        }

        this.model.set('textWeight', _textWeight, {silent:true});

        if(!this.model.get('textStyle')) {
            this.model.set('textStyle', 'normal', {silent:true});
            this.model.set('italicSelection', this.unselectedColor, {silent:true});
        }

        const styles = ['italic', 'italic !important'];

        if (styles.includes(this.model.get('textStyle'))) {
            this.model.set('italicSelection', this.selectedColor, {silent:true});
        }        

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name,
              oldValue = this.model.get(propName);
        let propVal = ev.currentTarget.value;
        
        if (propName === 'textWeight') {
            var weight = this.model.get('textWeight');
            if (this.isThemeProperty(weight)) {//PF-2201 - Forms / Reports - General Bold / Italic
                weight = this.resolveAttributes(weight, 'textWeight');
            }
            if (weight.indexOf('bold') > -1) {
                this.model.set('boldSelection', this.unselectedColor, { silent: true });
                propVal = 'normal';
            } else {
                this.model.set('boldSelection', this.selectedColor, { silent: true });
                propVal = 'bold';
            }
        }

        if (propName === 'textStyle') {
            var style = this.model.get('textStyle');
            if (this.isThemeProperty(style)) {//PF-2201 - Forms / Reports - General Bold / Italic
                style = this.resolveAttributes(style, 'textStyle');
            }
            if (style.indexOf('italic') > -1) {
                this.model.set('italicSelection', this.unselectedColor, { silent: true });
                propVal = 'normal';
            } else {
                this.model.set('italicSelection', this.selectedColor, { silent: true });
                propVal = 'italic';
            }
        }

        this.model.set(propName, propVal);
        if ( this.isThemeProperty(oldValue) ) {
            themeService.deattachTheme(this);
        }
    }

    resolveAttributes(base, name) {
        let fontPropsArray = themeService.resolve(base).split(',');
        let result = 'normal';
        if (name === 'textWeight') {
            if (fontPropsArray[2]) {
                result = fontPropsArray[2].trim().toLowerCase();
            }
        } else {
            if (fontPropsArray[3]){
                result =  fontPropsArray[3].trim().toLowerCase();
            }
        }
        return result;
    }

    selectMask(value) {
        let retValue;
        switch (value) {
            case 'bold !important':
            case 'bold':
            case 'italic !important':     
            case 'italic':
                retValue = this.selectedColor;
                break;
            default: 
                retValue = this.unselectedColor;
                break;
        }

        return retValue;
    }

    render() {
        const alignRightBI = Immutable.Set([
            'control_text_input',
            'control_multiple_text_input',
            'control_numeric_input',
            'control_date_input',
            'control_date_calendar',
            'control_time_input',
            'control_checkbox_group',
            'control_mask_text_input',
            'control_image_input',
            'control_radio_button_group',
            'control_image_input',
            'control_numeric_stepper',
            'control_password_input',
            'control_vertical_slider',
            'control_horizontal_slider',
            'control_ranking',
            'control_filter_input',
            'control_text',
            'control_small_text',
            'control_large_heading',
            'control_medium_heading',
            'control_small_heading',
            'control_bullet_text',
            'control_list',
            'control_progress_bar',
            'control_file_attachment',
            'control_bar_chart',
            'control_filter_selector',
            'control_line_chart',
            'control_pie_chart',
            'control_value'
        ]);
        
        this.model.set('isMultipleSelection', (listService.selected.size > 1), constants.MODEL_SILENT);
        this.model.set('alignRightBI',alignRightBI,{silent: true});
        super.render();

        let props = this.model.toJSON();

        if ( this.isThemeProperty(props.textWeight)) {
            props.textWeight = this.resolveAttributes(props.textWeight, 'textWeight');
        }
        props.boldSelection = this.selectMask(props.textWeight);

        if ( this.isThemeProperty(props.textStyle)) {
            props.textStyle = this.resolveAttributes(props.textStyle, 'textStyle');
        }
        props.italicSelection = this.selectMask(props.textStyle);

        this.$el.html(this.template( props ));

        this.delegateEvents(); 

        return this;
    } 
}

export default StyleTextStyle;
